<template>
  <div class="row">
    <snappy-table
      :endpoint="'vessels/' + vesselId + '/campaigns'"
      :columns="['name', 'subscribers_count', 'active', 'launch', 'created_at', 'actions']"
      :template-methods="columnTemplates(timezone)"
      :templated-slot-names="['name', 'active', 'actions']"
      :headings="['Campaign', 'Subscribers', 'Status', 'Launch Date', 'Created', 'Actions']"
      :handle-row-click="onRowClick"
      :default-ordering="{column: 'updated_at'}"
      record-type="Campaigns"
    >
      <template #name="{ row }">
        <svg v-if="row.alert" v-tooltip="`Warning: ${row.alert}`" style="fill: #ee383a; margin-right: 10px;" xmlns="http://www.w3.org/2000/svg" height="0.75em" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>
        {{ row.name }}
        <span class="label label-id">ID: {{ row.id }}</span>
      </template>

      <template #active="{ row }">
        <div>
          <span v-if="row.active" class="label label-success">RUNNING</span>
          <span v-else class="label label-default">STOPPED</span>
        </div>
      </template>

      <template #actions="{ row }">
        <div class="d-flex">
          <a
            :href="'edit/?sk_token=' + campaignToken(row.id)"
            class="btn btn-sm actionButton"
            title="Edit"
            v-tooltip="'Edit Campaign'"
          >
            <i class="fas fa-fw fa-edit"></i>
          </a>
          <a
            :href="'/inventory/campaigns/subscribers/?sk_token=' + campaignToken(row.id)"
            class="btn btn-sm actionButton"
            title="Manage Subscribers"
            v-tooltip="'Manage Subscribers'"
          >
            <i class="fas fa-fw fa-address-book"></i>
          </a>
          <a
            :href="'/inventory/campaigns/groups/?sk_token=' + campaignToken(row.id)"
            class="btn btn-sm actionButton"
            title="Manage Groups"
            v-tooltip="'Manage Groups'"
          >
            <i class="fas fa-fw fa-users"></i>
          </a>
          <button
            @click="onDuplicateCampaignClick($event, row.id)"
            class="btn btn-sm actionButton duplicateCampaign"
            :disabled="duplicating"
            title="Duplicate Campaign"
            type="button"
            v-tooltip="'Duplicate Campaign'"
          >
            <i class="fas fa-fw" :class="duplicating === row.id ? 'fa-spinner fa-spin' : 'fa-clone'"></i>
          </button>
        </div>
      </template>
    </snappy-table>
    <delete-records type="campaigns" class="deleteCampaigns"></delete-records>
  </div>
</template>

<script>
import SnappyTable from '../../components/SnappyTable';
import DeleteRecords from '../../components/DeleteRecords';
import columnTemplates from '../../mixins/tables/columnTemplates';
import {duplicateCampaign} from '../../utility/api/campaign/duplicateCampaign';
import {listenToPusherNotifications} from "../../utility/notifications/listenToPusherNotifications";
export default {
  name: 'campaigns-table',
  components: {SnappyTable, DeleteRecords},
  mixins: [columnTemplates],
  methods: {
    onRowClick(event) {
      window.location.href = 'manage/?sk_token=' + this.campaignToken(event.row.id);
    },
    campaignToken(campaignId) {
      return btoa('campaign_id=' + campaignId);
    },
    async onDuplicateCampaignClick(event, campaignId) {
      event.stopPropagation();
      listenToPusherNotifications((notification) => {
        if (notification.type === 'campaign-duplication-finished' && notification.original_campaign_id === campaignId) {
            this.$root.$emit('delete-notification', notification);
            window.location.href = notification.message.cta.url;
        }
      })
      this.duplicating = campaignId;
      await duplicateCampaign(campaignId)
          .then(response => {
            $.notify('Campaign duplication process has started, we will notify you once it completes.', 'success');
          })
          .catch(err => {
            $.notify('Campaign Duplication Failed - please try again', 'error');
          })
    },
  },
  data() {
    return {
      duplicating: false,
    };
  },
  props: {
    vesselId: {
      type: Number,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
  },
};
</script>
